import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  buttonText: {
    paddingLeft: theme.spacing(1)
  },
  button: {
    fontSize: "0.75rem",
    fontWeight: 500,
    marginLeft: theme.spacing(-1)
  }
}));

function RemoveButton(props) {
  const classes = useStyles();
  const { onClick } = props;
  return (
    <Button
      variant="text"
      color="primary"
      onClick={onClick}
      className={classes.button}
    >
      <span className={classes.buttonText}>Remove</span>
    </Button>
  );
}

export default RemoveButton;

RemoveButton.propTypes = {
  onClick: PropTypes.func
};
